import {
  Box,
  Link,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import React, { memo } from 'react';

type Props = {
  colSpan: number;
  error?: boolean;
  noResultsMessage?: React.ReactNode;
};

const TableBodyMessage: React.FC<Props> = ({
  colSpan,
  error,
  noResultsMessage,
}) => (
  <TableBody>
    <TableRow>
      <TableCell colSpan={colSpan}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height={200}
        >
          {error ? (
            <Box data-testid="tableMessage-error">
              <Box mb={3} textAlign="center">
                <Typography variant="h4">Sorry, server error</Typography>
              </Box>
              <Box>
                <Typography variant="body1">
                  If you&apos;ve tried refreshing the page and it still
                  doesn&apos;t work,{' '}
                  <Link
                    href="mailto:cambridge-identity@cambridgeassessment.org.uk"
                    underline="always"
                  >
                    contact us
                  </Link>
                  .
                </Typography>
              </Box>
            </Box>
          ) : (
            <Box data-testid="tableMessage-noData" textAlign="center">
              <Box mb={2}>
                <Typography variant="h4">0 results were found</Typography>
              </Box>
              {noResultsMessage}
            </Box>
          )}
        </Box>
      </TableCell>
    </TableRow>
  </TableBody>
);

export default memo(TableBodyMessage);
